import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'
import { DiffuseEndOfStayAppreciationsInput, DiffuseEndOfStayAppreciationsResponse } from './types'

/** Same sharing from the OTO individuel periods list: ids are période ids. */
export const diffuseOtoIndividualPeriodsEndOfStayAppreciations = (
  input: DiffuseEndOfStayAppreciationsInput
) => {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.diffuseOtoIndividualPeriodsEndOfStayAppreciations.url, null)
    )
    .post<DiffuseEndOfStayAppreciationsResponse>(input)
}
